import React from 'react'
import { Box, Typography } from '@mui/material'

interface PageMessageProps {
  message: string
  variant?: 'body1' | 'h6' | 'h5' | 'h4'
}

/**
 * Reusable component for displaying loading, error, or other status messages
 * with consistent styling that matches app-container pattern
 */
export const PageMessage: React.FC<PageMessageProps> = ({
  message,
  variant = 'body1',
}) => {
  return (
    <Box mt={2} ml={2} pl={'1.5rem'}>
      <Typography variant={variant}>{message}</Typography>
    </Box>
  )
}
